var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation-token"},[_c('div',{staticClass:"validation-token__wrapper"},[_c('div',{staticClass:"validation-token__content",class:{ 'validation-token__content--visible': _vm.isIconResultVisible }},[(!_vm.haveResponse)?_c('VSpinnerIconLoader',{attrs:{"loaderOptions":_vm.iconResultMessageData}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }